module.exports = "<div class=\"clearfix form-control\" style=display:flex;width:100%> {{#if unvisible}} <a href=javascript:void(0); class=info>权限受限</a> {{else if be_control_condition }} <a href=javascript:void(0); class=info>被修改条件限制</a> {{else}} <textarea class=\"ui-width textArea\" disabled=disabled value={{value}}></textarea> <div style=float:left;display:flex class=form-print-icon> {{#if required}} <span id=requiredLogo class={{requiredClass}}></span> {{/if}} </div> {{/if}} </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/textarea-control/textarea-control.html
// module id = 1921
// module chunks = 50